<template>
  <div class="blog-area with-top-border pb-75 pt-100">
    <div class="container">
      <div class="section-title">
        <span class="sub-title">Blog & Insights</span>
        <h2>Nossos artigos e recursos mais recentes</h2>
      </div>
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-6 col-md-6" data-aos="fade-up" data-aos-duration="1200">
          <div class="single-blog-post">
            <div class="image">
              <router-link to="/blog-details" class="d-block">
                <img src="../../assets/images/blog/blog1.jpg" alt="blog-image">
              </router-link>
            </div>
            <div class="content">
              <ul class="meta">
                <li>
                  <i class="ph-tag"></i>
                  <router-link to="/blog-tag">Desenvolvimento</router-link>
                </li>
                <li>
                  <i class="ph-calendar-check"></i>
                  15 Jun, 2024
                </li>
              </ul>
              <h3>
                <router-link to="/blog-details">Vue.js 3: As principais novidades e como migrar</router-link>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
          <div class="single-blog-post">
            <div class="image">
              <router-link to="/blog-details" class="d-block">
                <img src="../../assets/images/blog/blog2.jpg" alt="blog-image">
              </router-link>
            </div>
            <div class="content">
              <ul class="meta">
                <li>
                  <i class="ph-tag"></i>
                  <router-link to="/blog-tag">UX/UI</router-link>
                </li>
                <li>
                  <i class="ph-calendar-check"></i>
                  08 Jun, 2024
                </li>
              </ul>
              <h3>
                <router-link to="/blog-details">10 tendências de design para aplicações web em 2024</router-link>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
          <div class="single-blog-post">
            <div class="image">
              <router-link to="/blog-details" class="d-block">
                <img src="../../assets/images/blog/blog3.jpg" alt="blog-image">
              </router-link>
            </div>
            <div class="content">
              <ul class="meta">
                <li>
                  <i class="ph-tag"></i>
                  <router-link to="/blog-tag">Negócios</router-link>
                </li>
                <li>
                  <i class="ph-calendar-check"></i>
                  01 Jun, 2024
                </li>
              </ul>
              <h3>
                <router-link to="/blog-details">Como a transformação digital impacta pequenas empresas</router-link>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Blog'
}
</script>